export const Production = 'production'
export const Development = 'development'
